import React from 'react'
import ReactDOM from 'react-dom/client'
import { ApiProvider, App } from '@tn/ui'
import '@tn/ui/styles.css'
import { HttpApiClient } from './HttpApiClient'
import { EsoAuthGate } from './EsoAuthGate'
import { variantApps } from './variantApps'

const apiClient = new HttpApiClient('/api')

const matchedPrefix = Object.keys(variantApps).find(p => window.location.pathname.startsWith(p))
const RootApp = matchedPrefix ? variantApps[matchedPrefix] : App

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element #root not found')

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <EsoAuthGate>
      <ApiProvider client={apiClient}>
        <RootApp />
      </ApiProvider>
    </EsoAuthGate>
  </React.StrictMode>
)
